import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
} from '@angular/core';
import { type IMedia } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { MediaDisplayItem } from '../../media-display-item';

@Component({
  selector: 'pr-media-tile',
  templateUrl: './media-tile.component.html',
  styleUrls: ['./media-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MediaTileComponent extends MediaDisplayItem {
  showImageName = input(true);
  showFileName = input(true);
  showDate = input(true);

  @Input()
  set media(media: WithRef<IMedia>) {
    if (media) {
      this.media$.next(media);
      this.namedDocsToTags.namedDocs$.next(media.tags);
    }
  }
}
